import { motion } from "framer-motion";
import { useLanguage } from "@/i18n";
import { fileUrl, isVideo } from "@/api";

export const Space = ({ spaces }) => {
  const { t } = useLanguage();
  if (!spaces.length) return null;
  return (
    <section id="space" className="px-4 sm:px-8 lg:px-16 py-20 sm:py-28 border-t border-white/10" data-testid="space-section">
      <p className="font-mono2 text-[11px] tracking-[0.3em] uppercase text-zinc-500 mb-3">04 —</p>
      <h2 className="font-display uppercase text-5xl sm:text-7xl tracking-wide">{t("space_title")}</h2>
      <p className="text-zinc-400 mt-3 max-w-xl">{t("space_subtitle")}</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mt-12">
        {spaces.map((s, i) => (
          <motion.div key={s.id} data-testid={`space-image-${i}`}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.12 }}
            className={`overflow-hidden group ${i % 2 ? "md:mt-16" : ""}`}>
            {isVideo(s.image) ? (
              <video src={fileUrl(s.image)} autoPlay muted loop playsInline
                className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-700" />
            ) : (
              <img src={fileUrl(s.image, 1200)} alt={s.title} loading="lazy" decoding="async"
                className="img-bw w-full aspect-[4/3] object-cover group-hover:scale-105" />
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
};
